import React from 'react';
import styled from 'styled-components';

const LoadingIcon = () => {
  return (
    <svg version="1.1" id="loader-1" x="0px" y="0px"
      width="40px" height="40px" viewBox="0 0 50 50" xmlSpace="preserve">
      <path fill="#000" d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z">
        <animateTransform attributeType="xml"
          attributeName="transform"
          type="rotate"
          from="0 25 25"
          to="360 25 25"
          dur="0.6s"
          repeatCount="indefinite"/>
      </path>
    </svg>
  );
};

const Box = styled.div`
  height: 50vh;
  position: relative;
`;
const Wrapper = styled.div`
  display: block;
  position: absolute;
  height: 40px;
  width: 40px;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  margin: auto;

  & > svg path,
  & > svg rect{
    fill: #6633cc;
  }
`;

const Loading = () => {
  return (
    <Box><Wrapper><LoadingIcon /></Wrapper></Box>
  );
};

export default Loading;



// WEBPACK FOOTER //
// ./src/Messages/Loading.js